import { jsx } from 'react/jsx-runtime';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { fixedArea } from '../../../shared/styles/fixedArea.vanilla.mjs';
import { useSingleSelectContext } from '../../contexts/context.mjs';

const SingleSelectContentAffix = forwardRef(({ className: classNameFromProps, ...props }, forwardedRef) => {
  const { onContentAffixElementChange } = useSingleSelectContext("ContentAffix");
  const className = classNames(fixedArea({ side: "top" }), classNameFromProps);
  const composedRef = useComposedRefs(
    forwardedRef,
    (element) => onContentAffixElementChange(element)
  );
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      "data-scope": "single-select",
      "data-part": "content-affix",
      className,
      ref: composedRef,
      ...props
    }
  );
});

export { SingleSelectContentAffix as SelectContentAffix };
//# sourceMappingURL=ContentAffix.mjs.map
